import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  rows: {
    id: string;
    nome: string;
    marcada: boolean;
  }[];
}

// tipagem do que o hook retorna
export type IReponse = IResponseData['rows'];

async function getPermissoesUsuario(usuario_id): Promise<IReponse> {
  const response = await backend.get<IResponseData>(`/lista-permissoes`, {
    params: {
      usuario_id,
    },
  });
  return response.data.rows;
}

export function usePermissoesUsuario(usuario_id) {
  return useQuery(
    ['permissoes-usuario', usuario_id],
    () => getPermissoesUsuario(usuario_id),
    {
      // keepPreviousData: true,
      // staleTime: 1000 * 60 * 5,
      // cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: true,
    },
  );
}
